import { Injectable } from '@angular/core';
import { EntityDto, Rest, RestService } from '@ralba/shared';
import { RequestArchiveInputDto, ArchiveArgsDto } from '@tpa/api';

@Injectable({ providedIn: 'root' })
export class CompanyArchiveHttpApiService {
  constructor(private rest: RestService) {}

  public getArgs() {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/archive/get-args',
    };
    return this.rest.request<null, Rest.AbpResponse<ArchiveArgsDto>>(request);
  }

  public archive(body: RequestArchiveInputDto) {
    const request: Rest.Request<RequestArchiveInputDto> = {
      method: 'POST',
      url: '/api/archive/archive',
      body
    };
    return this.rest.request<RequestArchiveInputDto, Rest.AbpResponse<void>>(request);
  }
}
